<div class="main" appViewportObserver (isVisible)="initData()">
  <div class="flex justify-between items-center gap-4">
    <h2 class="text-2xl">
      {{ DashboardTranslateKeys.PROCESS_EFFICIENCY | translate }}
    </h2>
    <div class="header__splitter grow"></div>
    <p-button
      outlined="true"
      severity="secondary"
      (click)="toggleContent()"
      [icon]="isCollapsed() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
    />
  </div>
  <div
    class="content transition-all duration-300 ease-in-out overflow-hidden"
    [ngClass]="{
      'h-auto opacity-100': !isCollapsed(),
      'h-0 opacity-0': isCollapsed()
    }"
  >
    <div class="grid grid-cols-2 gap-3">
      <div class="stats__card">
        <h4 class="text-[#44546F] font-semibold">
          {{ DashboardTranslateKeys.AVERAGE_TIME_BETWEEN_APP_HIR | translate }}
        </h4>
        <h5 class="text-[#626F86] mt-2">
          {{ DashboardTranslateKeys.AVERAGE_DAYS_RECRUIT | translate }}
        </h5>
        <app-filters
          [showYearPicker]="true"
          (yearPickerChanged)="updateRecruitmentDelayYear($event)"
          [disabled]="isLoadingRecruitmentDelay()"
        />
        <div class="mt-7">
          @if(isLoadingRecruitmentDelay()|| !averageHiringObjects){
          <app-skeleton-dash-card />
          }@else {
          @defer (on viewport; prefetch on idle) {
          <app-column-chart
            id="average-application-hiring"
            [objects]="averageHiringObjects"
          />
          } @placeholder {
          <app-skeleton-dash-card />
          }
          }
        </div>
      </div>
      <div class="stats__card">
        <h4 class="text-[#44546F] font-semibold">
          {{
            DashboardTranslateKeys.AVERAGE_TIME_BETWEEN_PUB_CLOS_RECR
              | translate
          }}
        </h4>
        <h5 class="text-[#626F86] mt-2">
          {{ DashboardTranslateKeys.FROM_OFFER_TO_HIR | translate }}
        </h5>
        <app-filters
          [showYearPicker]="true"
          (yearPickerChanged)="updatePublicationClosingYear($event)"
          [disabled]="isLoadingPublicationClosing()"
        />
        <div class="mt-7">
          @if(isLoadingPublicationClosing() || !averagePublicationClosing){
          <app-skeleton-dash-card />
          }@else {
          @defer (on viewport; prefetch on idle) {
          <app-column-chart
            id="average-publication-closing"
            [objects]="averagePublicationClosing"
          />
          } @placeholder {
          <app-skeleton-dash-card />
          }
          }
        </div>
      </div>
    </div>
  </div>
</div>
